/**
 * Check if a user is eligible to retake the quiz based on a 30-day cooldown.
 * @param lastAttempt - The date of the last quiz attempt, or null if never attempted
 * @param now - The current date (defaults to new Date())
 * @returns An object with eligibility status, next eligible date, and remaining days
 */
export function isEligibleForRetake(
  lastAttempt: Date | null,
  now = new Date()
): {
  eligible: boolean;
  nextEligible: Date | null;
  remainingDays: number;
} {
  // If never attempted, eligible immediately
  if (lastAttempt === null) {
    return {
      eligible: true,
      nextEligible: null,
      remainingDays: 0,
    };
  }

  // Calculate next eligible date (30 days after last attempt)
  const nextEligible = new Date(lastAttempt);
  nextEligible.setDate(nextEligible.getDate() + 30);

  // Check if current time is past the eligible date
  const eligible = now >= nextEligible;

  // Calculate remaining days (ceiling to always round up)
  const msRemaining = nextEligible.getTime() - now.getTime();
  const daysRemaining = Math.ceil(msRemaining / (1000 * 60 * 60 * 24));
  const remainingDays = Math.max(0, daysRemaining);

  return {
    eligible,
    nextEligible,
    remainingDays,
  };
}
